var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgRatingStarGold = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: " 0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.653 7.25c.315-.32.426-.79.29-1.227a1.153 1.153 0 00-.927-.815l-3.874-.588a.505.505 0 01-.38-.289L9.028.667A1.134 1.134 0 008 0c-.44 0-.834.256-1.029.667L5.24 4.332a.508.508 0 01-.381.289l-3.874.587c-.436.066-.79.379-.927.816-.136.437-.025.907.29 1.227l2.803 2.852a.54.54 0 01.146.468l-.66 4.027c-.06.355.03.7.25.971.34.424.937.553 1.414.292l3.464-1.902a.5.5 0 01.472 0l3.465 1.902c.168.092.348.139.534.139.338 0 .66-.157.88-.43a1.21 1.21 0 00.25-.972l-.661-4.027a.54.54 0 01.146-.468l2.803-2.852z",
    fill: "#FFBB52",
    fillRule: "evenodd"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRatingStarGold, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rating-star-gold.38c0de18.svg";
export { ForwardRef as ReactComponent };